import React, {useMemo} from "react";
import { Persona, AvatarGroup, AvatarGroupItem, Label, makeStyles, shorthands, makeResetStyles } from "@fluentui/react-components";
import { customTokens } from "../../utils/Theming";

const useBaseClassName = makeResetStyles({
    ...shorthands.padding(customTokens.spacingVerticalL, customTokens.spacingHorizontalMNudge, customTokens.spacingVerticalMNudge),
});
const useStyles = makeStyles({
    personaLabel: {
        ...shorthands.padding(customTokens.spacingVerticalSNudge, customTokens.spacingHorizontalMNudge),
        borderRadius: '15px',
        display: 'inline-block',
        backgroundColor: customTokens.colorBadgeBackground,
    },
    personaPrimaryText: {
        marginBottom:'5px'
    },
    avatarGroup: {
        gridRowStart: 'span 5',
        alignSelf: 'start',
        marginRight: customTokens.spacingHorizontalM,
    }
});

export default function RelationContactRow({relationContact}) {
    const baseClassName = useBaseClassName();
    const classes = useStyles();
    const person = relationContact ? relationContact.Person : null;
    const relationName = relationContact ? relationContact.relation : null;

    const personName = useMemo(() => {
        if (!person) {
            return '';
        }
        return person.firstName  + (person.infix ? (' ' + person.infix) : '') + ' ' + person.lastName;
    }, [person]);

    const renderAvatarGroup = (Component, props) => {
        //let vacancyImage = null;
        //let candidateImage = null;
        let relationContactImage = null;
        let relationImage = null;

        if (relationContact?.contactImage) {
            relationContactImage = {
                src: `data:${relationContact.contactImage.mime};base64,${relationContact.contactImage.base64stream}`
            };
        }

         if (relationContact?.relationImage) {
            relationImage = {
                src: `data:${relationContact.relationImage.mime};base64,${relationContact.relationImage.base64stream}`
            };
        }

    return (
        <AvatarGroup className={classes.avatarGroup} layout="stack" size={56}>
            <AvatarGroupItem name={personName} key='relationContact' image={relationContactImage} />
            <AvatarGroupItem name={relationName} key='relationName' image={relationImage} />
        </AvatarGroup>
        )
    };


    return (
        <div className={baseClassName}>
            <Persona
                primaryText={
                    <>
                        <div className={classes.personaPrimaryText}>{personName}</div>
                    </>
                }
                secondaryText={relationName}
                size="huge"
                avatar={{ children: renderAvatarGroup}}
            />
        </div>        
        );
}